interface Props {
  className?: string;
}

const AttachedFileIcon = ({ className }: Props): JSX.Element => {
  return (
    <svg
      className={className}
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0498 18.8H1.54977C1.35086 18.8 1.1601 18.721 1.01946 18.5804C0.878811 18.4397 0.7998 18.249 0.799805 18.05V1.55005C0.7998 1.35114 0.878811 1.16038 1.01946 1.01973C1.1601 0.879074 1.35086 0.800054 1.54977 0.800049H10.5501L15.7998 6.05005V18.05C15.7998 18.249 15.7208 18.4397 15.5802 18.5804C15.4395 18.721 15.2487 18.8 15.0498 18.8V18.8Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5498 0.800049V6.05005H15.8006"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AttachedFileIcon;
